import React, { useEffect, useState } from 'react'
import Loading from '@/component/loading/loading'
import Choice from './component/choice'
import { changeTime } from '@/utils/tool'
import { post } from '@/api/http'
import { useSearchParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { setItem } from '@/utils/storage'

import './exam.scss'

const Exam = () => {
  const navigate = useNavigate()
  const [showLoading, setShowLoading] = useState(false)
  const [totalTime, setTotalTime] = useState(0)
  const [resultData, setResultData] = useState({
    totalCount: 0,
    rightCount: 0,
    wrongCount: 0,
    score: 0,
  })
  const [paper, setPaper] = useState([])
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(-1)
  const [params] = useSearchParams()
  const unitId = params.get('id')

  let activeQuestion

  if (paper.length > 0 && paper.length > activeQuestionIndex) {
    activeQuestion = paper[activeQuestionIndex]
  }

  useEffect(() => {
    const getQuestions = async (id) => {
      setShowLoading(true)
      const res = await post(`jq/v5/knowledge/category-ids`, {
        categoryIds: [id],
      })

      console.log('Questions res:', res)

      const questionIds =
        res?.filter((item) => item.type === 4 && item.isShow) ?? []

      const questionsList = await post(`jq/v5/questions/batch`, {
        ids: questionIds.map((item) => item.knowledgeId),
      })

      console.log('Questions list:', questionsList)

      //随机出题，并且只考单选题
      const shuffledQuestions = [...questionsList]
        .filter((item) => item.question_type === 1)
        .sort(() => Math.random() - 0.5)

      setPaper(shuffledQuestions)
      setShowLoading(false)
    }

    getQuestions(unitId)
  }, [])

  useEffect(() => {
    let totalTimeTimer

    if (paper && paper.length > 0) {
      setNextActiveQuestion()
      setResultData((prevData) => ({
        ...prevData,
        totalCount: paper.length,
      }))
      setTimeout(() => {
        setShowLoading(false)

        totalTimeTimer = setInterval(
          () => setTotalTime((prevTime) => prevTime + 1),
          1000
        )
      }, 1000)
    }

    return () => {
      if (totalTimeTimer) {
        clearInterval(totalTimeTimer)
      }
    }
  }, [paper])

  const handIn = async () => {
    const rightCount = resultData.rightCount ?? 0
    const wrongCount = resultData.wrongCount ?? 0
    const totalCount = resultData.totalCount || paper.length
    const score = totalCount ? Math.floor((rightCount / totalCount) * 100) : 0

    const payload = {
      ...resultData,
      rightCount,
      wrongCount,
      totalCount,
      score,
      questions: paper,
      totalTime,
    }

    setResultData(payload)
    setItem('examResult', payload)
    navigate(`/pages/exam/result`, { replace: true })
  }

  const setNextActiveQuestion = () => {
    if (activeQuestionIndex >= paper.length - 1) {
      handIn()
      return
    } else {
      setActiveQuestionIndex((prevIndex) => prevIndex + 1)
    }
  }

  const testChoiceBack = (data) => {
    activeQuestion.userAnswer = { result: data.result, option: data.answer }
    if (data.result === 1) {
      setResultData((prevData) => ({
        ...prevData,
        rightCount: (prevData.rightCount ?? 0) + 1,
      }))
    } else {
      setResultData((prevData) => ({
        ...prevData,
        wrongCount: (prevData.wrongCount ?? 0) + 1,
      }))
    }
  }

  return (
    <div className="exam-wrap">
      {showLoading ? (
        <Loading loadingText="试卷生成中,请等待..." />
      ) : (
        <div className="exam-main">
          <div className="contain">
            {activeQuestion && activeQuestion.question_type === 1 && (
              <Choice
                question={activeQuestion}
                onTestChoiceBack={testChoiceBack}
                onNextQuestion={setNextActiveQuestion}
              />
            )}
          </div>
          <div className="tip">
            <div className="index">
              {activeQuestionIndex + 1}/{resultData.totalCount}
            </div>
            <div className="right">
              正确: <span className="number">{resultData.rightCount}</span>
            </div>
            <div className="wrong">
              错误: <span className="number">{resultData.wrongCount}</span>
            </div>
            <div className="time">用时：{changeTime(totalTime, 2)}</div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Exam
